import Empresa from "@/features/contabil/common/Empresa";
import { Entity } from "@/core/common/Entity";
import Debitos from "./Debito";

type ControleDebitoData = {
  empresa: Empresa;
  debitos: Debitos[];
};
export default class ControleDebito extends Entity<ControleDebitoData> {
  private constructor(params: ControleDebitoData) {
    super(params);
    Object.freeze(this);
  }

  static create(arams: ControleDebitoData): ControleDebito {
    return new ControleDebito(arams);
  }

  getProps(): ControleDebitoData {
    return this.props;
  }
}
